<div
  #filterByDatesAndOrder
  class="common-dropdown-container">
  <span-tooltip
    class="common-table-cell__title-text-label"
    [text]="filterByDates.label">
  </span-tooltip>
  <div>
    <button
      class="common-button__filter-order-button"
      (click)="toggleFilter($event)">
      <i class="lf-icon-filter-1 common-icon__md"
        ngClass="{{dateFilter ? 'common-button__filter-order-button--active lf-icon-filter-applied' : 'lf-icon-filter-1'}}">
      </i>
    </button>
    <p-overlayPanel
      [id]="'filterSearch-' + filterByDates.id" styleClass="common-dropdown-overlay__dates-container">
      <from-to-calendar
        [fromSave]="item.fromDate"
        [toSave]="item.toDate"
        (changeCalendar)="onChangeCalendar($event)">
      </from-to-calendar>
    </p-overlayPanel>
  </div>
  @if (item?.filterOrder) {
    <button
      class="common-button__filter-order-button"
    [ngClass]="{
      'common-button__filter-order-button--active': filterOrder === item?.filterOrder
    }"
      (click)="orderColumn()">
      <i class="common-icon__md"
        ngClass="{{filterOrder === item?.filterOrder && !order ? 'lf-icon-arrow-up' : 'lf-icon-arrow-down'}}">
      </i>
    </button>
  }
</div>
